<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <p class="phone-number">
          <span>{{phoneNumber}}</span></p>
        <p
          class="description">{{this.textService.keyValueMapping('paymentApprovalSMSDescription', 'Tutarındaki işlemi onaylamanız için telefonunuza SMS gönderilmiştir. Bu mesajı EVET yazarak cevaplayıp onaylayabilirsiniz.', sdkInitTexts)}}
          <label
            class="text-style">{{this.textService.keyValueMapping('paymentApprovalSMSTimerText', 'İşlemi onaylamanız için kalan süre:', sdkInitTexts)}}
            <label>
              <nz-countdown [nzValue]="deadline" (nzCountdownFinish)="stop()" [nzFormat]="'mm:ss'"
                            [nzValueStyle]="{'font-weight': 'bold', 'font-size':'18px'}"></nz-countdown>
            </label></label>
        </p>
        <div class="col-12 px-0 d-flex justify-content-center">
          <label class="send-again" (click)="makePayment()">
            {{this.textService.keyValueMapping('paymentApprovalSendSMSButton', 'SMS\'i tekrar gönder.', sdkInitTexts)}}
          </label>
        </div>
        <div class="col-12 px-0 d-flex justify-content-center">
          <img class="edit" [src]="'assets/images/png/sms-logo.png'" [srcset]="'assets/images/png/sms-logo@2x.png 2x, assets/images/png/sms-logo@3x.png 3x'" alt="logo">
        </div>
      </div>
    </div>
  </div>
</div>
